import axios from 'axios';

type ProductType = 'orgBilling' | 'appointmentDesk' | undefined;

export const getStripeCustomerId = async (
  productType: ProductType,
  userId?: string,
) => {
  const { data: customerId } = await axios.get<string>(
    `/billing/stripe_customer_id`,
    {
      params: {
        productType,
        userId,
      },
    },
  );

  return customerId;
};
